import React from 'react';
import '../template-file-css/document-file-template.css';


export const C3_DischargeSummary = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='C3_DischargeSummary' className='file-pdf-document'>
            <div className='file-template'>

                <table>
                    <tr>
                        <td className='w-750'>
                            <b>Diagnostic Impressions:</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Goals</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Goal(s):</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtGoals' name='txtGoals' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <b>Assessment</b>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Assessment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtAssessment' name='txtAssessment' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Recommendations:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtRecommendations' name='txtRecommendations' className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            Interventions
                            <span className='small'>(Client was engaged in the following interventions)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Interventions:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtInterventions' name='txtInterventions' className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Outcome/Results of Treatment:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='text' id='txtOutcomeResultsTreatment' name='txtOutcomeResultsTreatment' className='add-only' />
                        </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}











